import { useEffect } from 'react';
import { SpendingTrendsChart } from '../components/charts';
import { useAppStore } from '../store';
import type { Transaction, Category } from '../types';

const demoCategories: Category[] = [
  {
    id: 'alimentacion',
    name: 'Alimentación',
    parentId: null,
    color: '#FF9800',
  },
  { id: 'servicios', name: 'Servicios', parentId: null, color: '#2196F3' },
  { id: 'transporte', name: 'Transporte', parentId: null, color: '#607D8B' },
  {
    id: 'entretenimiento',
    name: 'Entretenimiento',
    parentId: null,
    color: '#00BCD4',
  },
  { id: 'compras', name: 'Compras', parentId: null, color: '#795548' },
];

function generateDemoTransactions(): Transaction[] {
  const transactions: Transaction[] = [];
  const now = new Date();
  let txId = 1;

  for (let monthsAgo = 5; monthsAgo >= 0; monthsAgo--) {
    const date = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
    const monthStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

    const baseAmounts: Record<string, number> = {
      alimentacion: 8000 + Math.random() * 2000,
      servicios: 2000 + Math.random() * 1000,
      transporte: 1500 + Math.random() * 500,
      entretenimiento: 1000 + Math.random() * 1500,
      compras: 4000 + Math.random() * 2000,
    };

    Object.entries(baseAmounts).forEach(([categoryId, amount]) => {
      transactions.push({
        id: `demo-tx-${txId++}`,
        date: `${monthStr}-15`,
        description: `${categoryId} expense`,
        amount: -amount,
        type: 'expense',
        categoryId,
        cardIdentifier: '1234',
        cardType: 'titular',
        isInstallment: false,
        importedAt: new Date().toISOString(),
        importBatchId: 'demo-batch',
      });
    });
  }

  return transactions;
}

export function ChartDemoPage() {
  useEffect(() => {
    useAppStore.setState({
      categories: demoCategories,
      transactions: generateDemoTransactions(),
      isInitialized: true,
      isLoading: false,
    });
  }, []);

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-near-black mb-8">
        Tendencia de Gastos
      </h1>

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold text-near-black mb-4">
          Últimos 6 meses
        </h2>
        <SpendingTrendsChart months={6} />
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold text-near-black mb-4">
          Últimos 12 meses
        </h2>
        <SpendingTrendsChart months={12} height={400} />
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold text-near-black mb-4">
          Solo Alimentación y Servicios
        </h2>
        <SpendingTrendsChart
          months={6}
          categories={['alimentacion', 'servicios']}
        />
      </div>
    </div>
  );
}
